import { defineStore } from 'pinia';

import * as state from './estateaccountingquebecdistribution.state';
import * as getters from './estateaccountingquebecdistribution.getters';
import * as actions from './estateaccountingquebecdistribution.actions';

export const useEstateAccountingQuebecDistributionStore = defineStore(
  'estateaccountingquebecdistribution',
  () => ({
    ...state,
    ...getters,
    ...actions
  })
);
